module.exports = __webpack_public_path__ + "static/img/p-24.55999a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-24.png
// module id = JpJ3
// module chunks = 0